var _templateObject = _taggedTemplateLiteralLoose(['\n  background: ', ';\n  border-color: ', ';\n  border-style: solid;\n  border-width: 1px;\n  color: ', ';\n  padding: 0.5rem 0.75rem;\n  transition-duration: 0.2s;\n  transition-function: ease-in-out;\n  transition-properties: background, border-color;\n\n  &:hover,\n  &:focus {\n    background: ', ';\n    border-color: ', ';\n  }\n\n  &[disabled] {\n    background: ', ';\n    border-color: ', ';\n    color: ', ';\n    cursor: not-allowed;\n  }\n'], ['\n  background: ', ';\n  border-color: ', ';\n  border-style: solid;\n  border-width: 1px;\n  color: ', ';\n  padding: 0.5rem 0.75rem;\n  transition-duration: 0.2s;\n  transition-function: ease-in-out;\n  transition-properties: background, border-color;\n\n  &:hover,\n  &:focus {\n    background: ', ';\n    border-color: ', ';\n  }\n\n  &[disabled] {\n    background: ', ';\n    border-color: ', ';\n    color: ', ';\n    cursor: not-allowed;\n  }\n']);

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

var Button = styled.button(_templateObject, function (props) {
  return props.theme.bg;
}, function (props) {
  return props.theme.border;
}, function (props) {
  return props.theme.fg;
}, function (props) {
  return props.theme.active;
}, function (props) {
  return props.theme.active;
}, function (props) {
  return props.theme.disabledBg;
}, function (props) {
  return props.theme.disabledBg;
}, function (props) {
  return props.theme.disabledFg;
});

Button.defaultProps = {
  theme: {
    active: '#9f0500',
    bg: '#d23823',
    border: '#d23823',
    fg: '#fff',
    disabledBg: '#ccc',
    disabledFg: '#888'
  }
};

Button.propTypes = {
  children: PropTypes.node.isRequired
};

export default Button;


//////////////////
// WEBPACK FOOTER
// ../ui-components/es/Button.js
// module id = 230
// module chunks = 4